import { ArrowRight, CheckCircle2 } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { Eyebrow, Reveal, scrollToId } from "../lib/ui";

const IMG_PRIVAT = "https://images.unsplash.com/photo-1728931710048-fa21f9f9340c?crop=entropy&cs=srgb&fm=jpg&q=80";

export const AudienceSection = () => {
  const navigate = useNavigate();

  return (
  <section className="py-16 sm:py-24 lg:py-28">
    <div className="mx-auto max-w-[1440px] px-6 sm:px-8 lg:px-12">
      <Reveal>
        <div
          data-testid="audience-card-intro"
          className="overflow-hidden rounded-3xl bg-brand-950 text-white"
        >
          <div className="grid items-stretch lg:grid-cols-2">
            <div className="flex flex-col items-start justify-center p-8 sm:p-12 lg:p-16">
              <Eyebrow dark>Henvendelse</Eyebrow>
              <h2 className="mt-5 text-3xl font-semibold tracking-[-0.02em] sm:text-4xl lg:text-[2.75rem] lg:leading-[1.15]">
                Privat eller erhverv — vi dækker begge
              </h2>
              <p className="mt-6 max-w-md text-base leading-relaxed text-white/75 sm:text-lg">
                Vi hjælper dig trygt og sikkert videre, hvad end din sag handler om. Fortæl
                os kort om din situation — så vender vi tilbage og hjælper dig med at finde
                næste skridt.
              </p>

              <div className="mt-10 flex flex-col items-start gap-5 sm:flex-row sm:items-center">
                <button
                  data-testid="audience-intro-cta"
                  onClick={() => navigate("/kontakt")}
                  className="group inline-flex items-center gap-3 rounded-full bg-white py-3 pl-7 pr-2.5 text-sm font-semibold text-brand-950 transition-colors duration-200 hover:bg-brand-50"
                >
                  Bliv kontaktet
                  <span className="flex h-8 w-8 items-center justify-center rounded-full bg-brand-950 text-white transition-transform duration-200 group-hover:rotate-[-45deg]">
                    <ArrowRight className="h-3.5 w-3.5" strokeWidth={2.2} />
                  </span>
                </button>
                <button
                  data-testid="audience-secondary-cta"
                  onClick={() => scrollToId("omraeder")}
                  className="group inline-flex items-center gap-2 text-sm font-semibold text-white transition-colors hover:text-brand-300"
                >
                  Læs mere
                  <ArrowRight className="h-4 w-4 transition-transform duration-200 group-hover:translate-x-1" />
                </button>
              </div>
            </div>

            <div className="relative min-h-[300px] p-6 sm:p-8 lg:p-10">
              <div className="h-full min-h-[300px] overflow-hidden rounded-2xl">
                <img
                  src={IMG_PRIVAT}
                  alt=""
                  className="h-full w-full object-cover"
                  loading="lazy"
                />
              </div>
              <div
                data-testid="audience-confirm-card"
                className="absolute bottom-6 left-6 max-w-[280px] rounded-2xl bg-white p-5 shadow-2xl shadow-brand-950/40 sm:bottom-10 sm:left-10"
              >
                <CheckCircle2 className="h-6 w-6 text-emerald-500" strokeWidth={1.8} />
                <p className="mt-3 text-sm font-semibold text-slate-900">
                  Din henvendelse er modtaget
                </p>
                <p className="mt-1.5 text-xs leading-relaxed text-slate-500">
                  Vi vender tilbage hurtigst muligt — så aftaler vi næste skridt sammen.
                </p>
              </div>
            </div>
          </div>
        </div>
      </Reveal>
    </div>
  </section>
  );
};

export default AudienceSection;